import script from "./SignUpPromoter.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpPromoter.vue?vue&type=script&setup=true&lang=js"

import "./SignUpPromoter.vue?vue&type=style&index=0&id=3808a5d6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3808a5d6"]])

export default __exports__